import { mapKeys } from 'lodash'

import { SIGN_OUT } from 'Global/Stores/auth'

const RUGS_RECENT_GET = 'API|RUGS/RECENT/GET'
const RUGS_RECENT_GET_FULFILLED = `FULFILLED_${RUGS_RECENT_GET}`
const RUGS_RECENT_GET_PENDING = `PENDING_${RUGS_RECENT_GET}`
const RUGS_RECENT_GET_REJECTED = `REJECTED_${RUGS_RECENT_GET}`

const RUGS_RECENT_MFD_GET = 'API|RUGS/RECENT_MFD/GET'
const RUGS_RECENT_MFD_GET_FULFILLED = `FULFILLED_${RUGS_RECENT_MFD_GET}`
const RUGS_RECENT_MFD_GET_PENDING = `PENDING_${RUGS_RECENT_MFD_GET}`
const RUGS_RECENT_MFD_GET_REJECTED = `REJECTED_${RUGS_RECENT_MFD_GET}`

const RUGS_RECENT_ORDERS_GET = 'API|RUGS/RECENT_ORDERS/GET'
const RUGS_RECENT_ORDERS_GET_FULFILLED = `FULFILLED_${RUGS_RECENT_ORDERS_GET}`
const RUGS_RECENT_ORDERS_GET_PENDING = `PENDING_${RUGS_RECENT_ORDERS_GET}`
const RUGS_RECENT_ORDERS_GET_REJECTED = `REJECTED_${RUGS_RECENT_ORDERS_GET}`

/**
 * Get request to API to get recent rugs.
 * @returns {Object} Action Object
 */
export const getRecent = () => ({
  meta: { url: `/api/v1/rugs/recent` },
  type: RUGS_RECENT_GET,
})

/**
 * Get request to API to get recent rugs marked for designers.
 * @returns {Object} Action Object
 */
export const getRecentMarkedForDesigners = () => ({
  meta: { url: `/api/v1/rugs/recentMarkedForDesigners` },
  type: RUGS_RECENT_MFD_GET,
})

/**
 * Post request to API to get recent orders.
 * @param {string} advisor
 * @param {array} additionalAdvisors
 * @returns {Object} Action Object
 */
export const getRecentOrders = (advisor, additionalAdvisors) => ({
  meta: {
    data: { additionalAdvisors, advisor },
    method: 'post',
    url: `/api/v1/rugs/recentOrders`,
  },
  type: RUGS_RECENT_ORDERS_GET,
})

const initialState = {
  errors: {
    recentMarkedForDesigners: false,
    recentOrders: false,
    recent: false,
  },
  pendings: {
    recentMarkedForDesigners: false,
    recentOrders: false,
    recent: false,
  },
  recent: {},
  recentMarkedForDesigners: {},
  recentOrders: {},
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case RUGS_RECENT_GET_FULFILLED:
      return {
        ...state,
        errors: {
          ...state.errors,
          recent: false,
        },
        pendings: {
          ...state.pendings,
          recent: false,
        },
        recent: mapKeys(payload.data, 'id'),
      }

    case RUGS_RECENT_GET_PENDING:
      return {
        ...state,
        errors: {
          ...state.errors,
          recent: false,
        },
        pendings: {
          ...state.pendings,
          recent: true,
        },
      }

    case RUGS_RECENT_GET_REJECTED:
      return {
        ...state,
        errors: {
          ...state.errors,
          recent: true,
        },
        pendings: {
          ...state.pendings,
          recent: false,
        },
      }

    case RUGS_RECENT_MFD_GET_FULFILLED:
      return {
        ...state,
        errors: {
          ...state.errors,
          recentMarkedForDesigners: false,
        },
        pendings: {
          ...state.pendings,
          recentMarkedForDesigners: false,
        },
        recentMarkedForDesigners: mapKeys(payload.data, 'id'),
      }

    case RUGS_RECENT_MFD_GET_PENDING:
      return {
        ...state,
        errors: {
          ...state.errors,
          recentMarkedForDesigners: false,
        },
        pendings: {
          ...state.pendings,
          recentMarkedForDesigners: true,
        },
      }

    case RUGS_RECENT_MFD_GET_REJECTED:
      return {
        ...state,
        errors: {
          ...state.errors,
          recentMarkedForDesigners: true,
        },
        pendings: {
          ...state.pendings,
          recentMarkedForDesigners: false,
        },
      }

    case RUGS_RECENT_ORDERS_GET_FULFILLED:
      return {
        ...state,
        errors: {
          ...state.errors,
          recentOrders: false,
        },
        pendings: {
          ...state.pendings,
          recentOrders: false,
        },
        recentOrders: mapKeys(payload.data, 'id'),
      }

    case RUGS_RECENT_ORDERS_GET_PENDING:
      return {
        ...state,
        errors: {
          ...state.errors,
          recentOrders: false,
        },
        pendings: {
          ...state.pendings,
          recentOrders: true,
        },
      }

    case RUGS_RECENT_ORDERS_GET_REJECTED:
      return {
        ...state,
        errors: {
          ...state.errors,
          recentOrders: true,
        },
        pendings: {
          ...state.pendings,
          recentOrders: false,
        },
      }

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
